import Component from './Component';
import ComponentStyles from './Styles';

export const Styles = ComponentStyles;
export const { PanelColumn, PanelGroup } = Styles;

export default Component;
